var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-layout"},[_c('div',{ref:"myDiv",staticClass:"sticky-top nav-bar"}),_vm._v(" "),_c('div',{staticClass:"main-layout__container"},[_c('div',{staticClass:"main-layout__body",style:(_vm.mainLayoutBodyStyles)},[_c('child')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }